if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      this.isPreOrder = this.hasAttribute('data-is-pre-order');
      this.showQty = this.hasAttribute('data-show-qty');
      this.maxQtyShown = Number(this.getAttribute('data-max-qty-shown') || '0');
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      // Init
      this.updateInventory(parseInt(this.dataset.inventoryQuantity, 10));
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(inventory.inventory_quantity);
      } else {
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     */
    updateInventory(count) {
      if (this.showQty) {
        this.inventoryNotice.innerText = count > 0 ? `${this.maxQtyShown > 0 && count > this.maxQtyShown ? `${this.maxQtyShown}+` : count } ${this.dataset.inStock}` : this.dataset.noStock;
      } else {
        this.inventoryNotice.innerText = count > 0 ? this.dataset.inStock : this.dataset.noStock;
      }
      this.setAttribute('data-inventory-state', count > 0 ? 'in-stock' : 'no-stock');
      this.hidden = count <= 0 && this.isPreOrder ? true : false;
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
